import { render } from "./LoadingSection.vue?vue&type=template&id=67fa01a4"
import script from "./LoadingSection.vue?vue&type=script&lang=js"
export * from "./LoadingSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__